import { gql } from "@apollo/client";

export const getFeedbackDetails = gql`
  query getFeedbackDetails($id: ID!) {
    getCheckIn(id: $id) {
      description
      startDate
      endDate
      surveyCheckin {
        isanonymous
        surveycheckin {
          answer
          options
          question
          userAnswer
          questionType
        }
      }
      usercheckin {
        items {
          userid
          isNewHighlight
          user {
            id
            firstName
            lastName
            profileImage {
              url
              fileName
            }
            department
            role
            designation
            status
          }
          id
          checkInStatus
          isNewFeedbackResponse
          surveyCheckin {
            isanonymous
            surveycheckin {
              answer
              options
              question
              userAnswer
              questionType
            }
          }
          usercomment
          responseDocument {
            fileName
            key
            uploadUrl
            url
          }
          attachmentLink {
            link
            title
            description
            image
          }
          requestFeedbackAttachments {
            fileType
            s3Link {
              bucket
              fileName
              key
              region
              uploadUrl
              url
              isNew
              __typename
            }
            isVideoUrl
          }
        }
      }
      multimediaCheckin {
        s3Link {
          url
          key
          fileName
        }
        isVideoUrl
        fileType
      }
      surveyLinks {
        link
        description
        title
        image
      }
      surveyMultimediaCheckin {
        fileType
        s3Link {
          bucket
          fileName
          key
          region
          uploadUrl
          url
          isNew
          __typename
        }
        isVideoUrl
        __typename
      }
    }
  }
`;
